import * as core from '../../../../../../../core'

import { query } from './dept-scatter.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.department-performance-scatter',
    description: 'Expense Entry vs. ASF scatterplot broken down by department.',
    name: 'RP Overview - Dept Performance Scatterplot',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
